import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Generates and downloads a PDF certificate from a DOM element
 * @param {HTMLElement} element - The DOM element to convert to PDF
 * @param {string} orderToken - The order token for the filename
 * @param {Object} cert - The certificate object
 * @throws {Error} - If PDF generation fails
 */
export async function generateCertificatePDF(element, orderToken, cert) {
  if (!element) {
    throw new Error("Certificate element not found");
  }

  // Store original styles
  const originalWidth = element.style.width;
  const originalHeight = element.style.height;
  const originalMaxWidth = element.style.maxWidth;

  // Temporarily apply A5 dimensions for PDF generation
  // A5 at 96dpi: 559px × 794px
  element.style.width = "559px";
  element.style.height = "794px";
  element.style.maxWidth = "559px";

  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      backgroundColor: "#f5f5f5",
      logging: false,
      useCORS: true,
      allowTaint: true,
      foreignObjectRendering: false,
      width: 559,
      height: 794,
    });

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a5",
    });

    const imgData = canvas.toDataURL("image/png");
    // A5 dimensions are 148mm x 210mm
    pdf.addImage(imgData, "PNG", 0, 0, 148, 210);
    pdf.save(`ODITI_DIGITAL_CERTIFICATE-${orderToken}-${cert.title.replaceAll(" ", "")}.pdf`);
  } finally {
    // Restore original styles
    element.style.width = originalWidth;
    element.style.height = originalHeight;
    element.style.maxWidth = originalMaxWidth;
  }
}
